<mat-sidenav-container>

  <mat-sidenav #sidenav mode="push">
    <div class="branding">
      <img [src]="logo" alt="logo"/>
      <span>Seguros</span>
    </div>
    <mat-nav-list *ngIf="persona && rolId">
      <a mat-list-item *ngFor="let item of navigationSideMenu" (click)="sidenav.close()" [routerLink]="[item.link]"
         routerLinkActive="active">
        {{item.label}}
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <div class="wrapper">

    <div class="toolbar toolbar-central" [style.position]="'fixed'" [class.mat-elevation-z4]="true">
      <div class="row header-top" *ngIf="personaId && persona && rolId">
        <div class="col col-md-4 hidden-sm head-title">
          <span><b>Ministerio de Ganadería, Agricultura y Pesca</b></span>
        </div>
        <div class="col-12 col-md-8 profile-data">
          <button mat-flat-button
                  (click)="onProfileClick()"
                  class="profile-data-btn">
            <fa-icon icon="user-circle"></fa-icon>
            <span class="btn-user-text ml-2">
              <span>{{persona.personaNombre}}</span> -
              <span class="btn-user-text-small">{{role ? role.rolNombre : ''}}</span>
             </span>
          </button>

          <div class="separator"></div>

          <button mat-flat-button
                  (click)="onLogoutClick()"
                  class="profile-data-btn">
            <span>Cerrar Sesión</span>
          </button>

          <div class="clock">
            {{clock}}
          </div>
        </div>
      </div>
      <mat-toolbar color="primary">
        <button mat-icon-button class="d-md-none" (click)="sidenav.open()">
          <fa-icon icon="bars"></fa-icon>
        </button>

        <div routerLink="" class="branding center d-flex d-sm-none">
          Seguros
        </div>
        <div routerLink="" class="branding center d-none d-sm-flex d-md-none">
          Seguros
        </div>
        <div routerLink="" class="branding d-none d-md-flex">
          <img [src]="logo" alt="logo"/>
          Seguros
        </div>

        <div class="spacer"></div>

        <div class="d-none d-md-inline-flex actions-link" *ngIf="personaId && persona && rolId">
          <div [class]="'nav-btn-cont'" *ngFor="let item of navigation">
            <div class="btn-sep" *ngIf="item.separator"></div>
            <div class="btn-cont-item">
              <button mat-button class="nav-button"
                      [routerLink]="[item.link]"
                      routerLinkActive="active">
                {{item.label}}
              </button>
              <div class="point" *ngIf="item.current"></div>
            </div>
          </div>
        </div>

      </mat-toolbar>
    </div>

    <div [class]="'content' + (personaId && persona && rolId ? ' content-logged' : '')"
         [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.data && o.activatedRoute.routeConfig.data.title">
      <router-outlet #o="outlet">
        <div *ngIf="isLoading" class="loading-indicator">
          <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
      </router-outlet>
    </div>

    <!--    <div class="footer">-->
    <!--      <div class="row">-->
    <!--        <div class="col-12 signature">-->
    <!--          &#169; <span class="year">{{year}}</span> - DSense |-->
    <!--          <br class="d-block d-sm-none">-->
    <!--          &lt;!&ndash; <fa-icon icon="rocket"></fa-icon> &ndash;&gt;-->
    <!--          Versión: {{version}}-->
    <!--          <span *ngIf="!isProd"> [Env:{{envName}}]</span>-->
    <!--          &lt;!&ndash;          <span *ngIf="!isProd"> [Mock:{{useMockServer}}]</span>&ndash;&gt;-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

  </div>

</mat-sidenav-container>
